var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.6313333 13.6346667h-2.3693333v-3.7126667c0-.88533333-.018-2.02466667-1.2346667-2.02466667-1.2353333 0-1.42399997.96333334-1.42399997 1.95933334v3.77800003h-2.36933333v-7.6346667h2.276v1.04066667h.03066667c.318-.6 1.09133333-1.23333334 2.24666663-1.23333334 2.4006667 0 2.8446667 1.58 2.8446667 3.63666667v4.1906667zm-10.0733333-8.67933337c-.76266667 0-1.37533333-.61733333-1.37533333-1.37666666 0-.75866667.61333333-1.37533334 1.37533333-1.37533334.76 0 1.376.61666667 1.376 1.37533334 0 .75933333-.61666667 1.37666666-1.376 1.37666666zm1.188 8.67933337h-2.376v-7.6346667h2.376zm10.0706667-13.6346667h-13.63600003c-.65266667 0-1.18066667.516-1.18066667 1.15266667v13.69466663c0 .6373334.528 1.1526667 1.18066667 1.1526667h13.63400003c.652 0 1.1853333-.5153333 1.1853333-1.1526667v-13.69466663c0-.63666667-.5333333-1.15266667-1.1853333-1.15266667z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1b865e712745297a748b36bcc49ee070.svg";
export { ForwardRef as ReactComponent };